import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Alert from 'react-s-alert';
import { IconEyeOff, IconEyeOn } from 'modules/common/components/Icons';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../actions';
import * as c from '../constants';
import pkg from '../../../../package.json';
import MiniLoader from '../../common/components/MiniLoader';
import CmsContext from '../../../context/CmsContext';
import MfaModal from '../modals/mfa/MfaModal';

const form = {
  email: '',
  password: '',
  profile_type: 'administrator',
  secret: '',
};

const demoData = JSON.parse(sessionStorage.getItem('demoData'));

function LoginContainer({ isLoading, login, history }) {
  const cmsContext = useContext(CmsContext);

  const setModal = useContext(ModalContext);

  const [hidden, setHidden] = useState({ hidden: false });
  const [formData, setFormData] = useState(form);

  const CMS_LOGO = cmsContext.findByType('LOGOS');
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');

  const cmsLogo = _.get(CMS_LOGO, 'CORE_LOGO.cdnUrl');
  const cmsLogoWhite = _.get(CMS_LOGO, 'CORE_LOGO_WHITE.cdnUrl');

  const displayLogoImage = !_.isEmpty(CMS_LOGO) ? (
    <img
      src={!cmsLogoWhite ? cmsLogo : cmsLogoWhite}
      className="front-icon-logo"
      alt="Local Government System"
    />
  ) : (
    <MiniLoader />
  );

  const handleOnChange = (e) => {
    e.preventDefault();
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    login(formData, (profile) => {
      if (profile.is_mfa_required === true) {
        setModal({
          isOpen: true,
          content: <MfaModal profile={profile} />,
          title: 'Multi-Factor Authentication',
          modalSize: 'modal-md',
        });
      } else {
        Alert.success('You have successfully logged in!');
        history.push('/');
      }
    });
  };

  return (
    <div className="login-page login-core login-background--core">
      <div className="container h-100">
        <div className="row h-100 d-flex align-items-center justify-content-center">
          <div className="col-md-12 mx-auto">
            <div className="login-section">
              <div className="header mb-4">
                {!_.isEmpty(demoData) ? (
                  <img
                    src={demoData.image_url}
                    alt="Local Government System"
                    style={{
                      width: 'auto',
                      height: `${demoData.height}px`,
                      fill: '#ffffff',
                    }}
                  />
                ) : (
                  displayLogoImage
                )}
              </div>
              <div className="content">
                <div className="login-box-smart-city">
                  <div className="welcome-intro">
                    <h2 className="title-smart-city cms-text-secondary">Access to Admin Portal</h2>
                  </div>
                  <form onSubmit={handleLogin} className="login-form">
                    <div className="form-group">
                      <label htmlFor="email" className="form-label-smart-city">Email Address</label>
                      <input
                        type="email"
                        placeholder="Email Address"
                        onChange={handleOnChange}
                        name="email"
                        value={_.get(formData, 'email') || ''}
                        id="loginUsername"
                        className="form-control form-control-lg"
                        style={{ border: '1px solid #D3D3D3', borderRadius: '8px' }} // smart-city
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="password" className="form-label-smart-city">Password</label>
                      <div className="inner-addon right-addon right-addon-button">
                        <input
                          type={hidden ? 'password' : 'text'}
                          placeholder="Password"
                          onChange={handleOnChange}
                          value={_.get(formData, 'password') || ''}
                          name="password"
                          id="loginPassword"
                          className="form-control form-control-lg form-control-icon"
                          style={{ border: '1px solid #D3D3D3', borderRadius: '8px' }} // smart-city
                        />
                        <button
                          type="button"
                          tabIndex={-1}
                          className="btn btn-right"
                          onClick={() => setHidden(!hidden)}
                        >
                          {hidden ? <IconEyeOn /> : <IconEyeOff />}
                        </button>
                      </div>
                    </div>
                    {/* <div className="form-helpers action">
                      <Link to="/forgot-password" className="link-action">
                        Forgot Password?
                      </Link>
                    </div> */}
                    <div className="pt-2">
                      <button
                        type="submit"
                        disabled={isLoading}
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary  cms-bg-color-primary cms-outline-color-primary btn-block btn-signin"
                        style={{
                          cursor: isLoading ? 'not-allowed' : 'pointer',
                          borderRadius: '8px',
                          fontWeight: 600,
                        }}
                      >
                        {isLoading && <i className="fas fa-spin fa-spinner" />}{' '}
                        Login
                      </button>
                    </div>
                  </form>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-center mt-3 text-muted">
                      {_.get(CMS_VARIABLES, 'LGU_NAME') === "Las Piñas" ? (
                        <small>Version {pkg.versionLp}</small>
                      ) : (
                        <small>Version {pkg.version}</small>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="msys-icon col-12">
            <div className="msys-icon-cont">
              <div> Powered by: </div>
              <div>
                <img className="msys-icon-img" alt="" src={_.get(CMS_LOGO, 'FOOTER_LOGO_CORE.cdnUrl')} />
              </div>
            </div>
          </div>
        </div>

        {/* <div className="fixed-bottom text-right">
          <button
            type="button"
            className="btn btn-link text-dark"
            onClick={handleAddModal}
          >
            +
          </button>
          <button
            type="button"
            className="btn btn-link text-dark"
            onClick={handleEditModal}
          >
            -
          </button>
          <button
            type="button"
            className="btn btn-link text-dark"
            onClick={handleSelectModal}
          >
            /
          </button>
        </div> */}
      </div>
    </div>
  );
}

LoginContainer.propTypes = {
  login: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: api.loading.indexOf(c.LOGIN) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(LoginContainer);